import { useSelector } from 'react-redux';
import { RootState } from 'src/types/store-types';

export const useSplashMessages = (): any => {
  const messages = useSelector((store: RootState) => store.messages);

  return messages.filter((m) => m.type === 'splash' && m.status === 'unread');
};
